import { render } from "./PropertySelfService.vue?vue&type=template&id=05e99283&scoped=true"
import script from "./PropertySelfService.vue?vue&type=script&lang=js"
export * from "./PropertySelfService.vue?vue&type=script&lang=js"

import "./PropertySelfService.vue?vue&type=style&index=0&id=05e99283&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e99283"]])

export default __exports__